module.exports = "/_next/static/images/AnomaliesBanner-887441e1bdb2477ea237564e0bfcc855.svg";